import { Button } from 'primereact/button';
import React from 'react'
import { useHistory } from "react-router-dom";

export default function NotFound() {
    const history = useHistory();

    return (
        <>
        <div className="login-body" style={{margin: '-16px'}}>
            <div className="login-panel"></div>

            <div className="login-content" style={{ marginTop: "8%"  }}>
                <div className="p-d-flex p-flex-column" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className="p-col-12 p-md-4" style={{ textAlign: "center" }}>
                        <img src="assets/layout/images/logo/icon.png" style={{ width: "150px" }} alt="logo" />
                    </div>
                </div>
                <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                    <div className="p-col-12 p-md-4">
                        <label style={{ fontSize: '25px', fontWeight: 'bold' }}>ระบบบริหารจัดการงานวางท่อ</label>
                    </div>
                </div>
                <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                    <div className="p-col-12 p-md-4">
                        <label style={{ fontSize: '23px' }}><span className="exception-name">PAGE</span> NOT FOUND</label>
                    </div>
                   
                </div>
                <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                    <div className="p-col-12 p-md-4">
                        <label style={{ fontSize: '20px' }}>ไม่พบหน้าดังกล่าว หรือไม่มีสิทธิ์เข้าใช้งาน</label>
                    </div>
                   
                </div>
                <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center",marginTop: "20px"  }}>
                    <Button
                        label="กลับหน้าจอหลัก"
                        className="p-button-info"
                        onClick={() => {
                            history.push("/");
                        }}
                        icon="pi pi-sign-in"
                        iconPos="right"
                    />
                   
                </div>               
            </div>
        </div>
        </>
    )
}
